import * as React from "react";
import * as Moment from "moment";
import "moment-duration-format";
import delay from "lodash-es/delay";

interface EventAddInputsProps {
    isEditing: boolean;
    isSegmented: boolean;
    startTime: number,
    endTime: number,
    disabled: boolean;
    isStartTimeValid: boolean;
    isEndTimeValid: boolean;
    currentWaveformDuration: number;
    handleStartChange: (value: any) => void;
    handleEndChange: (value: any) => void;
    handleStartBlur?: () => void;
}

export const EventAddInputs = ({ isEditing, isSegmented, startTime, endTime, disabled, isStartTimeValid, isEndTimeValid, currentWaveformDuration, handleStartChange, handleEndChange, handleStartBlur }: EventAddInputsProps): JSX.Element => {
    const maxTime = Moment.duration(currentWaveformDuration * 1000).format("HH:mm:ss");

    return (isSegmented ? <>
        <TimeInput id="startTimeInput" labelText="Start" value={startTime} onChange={handleStartChange} onBlur={handleStartBlur} isEditMode={!disabled} isValid={isStartTimeValid} maxTimeValue={maxTime} />
        <TimeInput id="endTimeInput" labelText="End" value={endTime} onChange={handleEndChange} isEditMode={!disabled} isValid={isEndTimeValid} maxTimeValue={maxTime} />
    </> : <TimeInput id="pointTimeInput" labelText="Position" value={startTime} onChange={handleStartChange} onBlur={handleStartBlur} isEditMode={!disabled} isValid={isStartTimeValid} maxTimeValue={maxTime} />);
}


interface TimeInputProps {
    id: string;
    labelText: string;
    value: number;
    isValid: boolean;
    onChange: (value: any) => void;
    onBlur?: () => void;
    isEditMode: boolean;
    maxTimeValue: string;
}

export const BasicTimeInput = ({ value, isValid, onChange, id, onBlur, isEditMode, maxTimeValue }: TimeInputProps): JSX.Element => {

    const [val, setVal] = React.useState(value);
    const [disableSetting, setDisableSetting] = React.useState(false);

    const inputRef = React.useRef<HTMLInputElement>();

    React.useEffect(() => {
        setVal(value * 1000);

        if (!disableSetting && inputRef.current !== null) {
            inputRef.current.value = Moment.utc(value * 1000).format("HH:mm:ss.SS");
        }
        
    }, [value]);

    //This is used to prevent the setting of the value on the time input.
    //The reason for this is that if the value is set by state / jquery then the second type in the
    //hour, seconds area gets registered as the first entry.
    React.useEffect(() => {
        delay(() => {
            setDisableSetting(false);
        }, 500);
    }, [disableSetting]);

    return (isEditMode ?
        <>
            <input
                id={id}
                ref={inputRef}
                type="time"
                step="0.01"
                min="00:00:00"
                max={maxTimeValue}
                style={!isValid ? { border: 'solid 1px red' } : null}
                className="form-control"
                disabled={false}
                onBlur={(e) => {
                    e.preventDefault();
                    onBlur && onBlur();
                    onChange(Moment.duration(val).asSeconds());
                }}
                onKeyPress={() => {
                    setDisableSetting(true);
                }}
                onKeyUp={() => {
                    setDisableSetting(true);
                }}
                onChange={(ev) => {
                    ev.preventDefault();

                    var value = Moment.duration(ev.target.valueAsNumber);
                    setVal(value.asMilliseconds());
                    onChange(value.asSeconds());
                }}
            />
        </> : <>
            <input
                id={id}
                type="time"
                step="0.01"
                className="form-control"
                disabled={true}
            />
        </>
    );
}

export const TimeInput = (props: TimeInputProps): JSX.Element => {

    return (
        <>
            <div className="input-group" style={{ width: "100%" }}>
                <label htmlFor={props.id} className="col-lg-3">{props.labelText}</label>
                <div className="col-lg-9">
                    <BasicTimeInput
                        {...props}
                    />
                </div>
            </div>
        </>
    );
}
